export const getNameParts = (name: string) => {
  const parts = name.split(' ').filter((x) => !!x);
  if (parts.length === 0) {
    return {};
  } else if (parts.length === 1) {
    return { firstName: parts[0] };
  } else if (parts.length === 2) {
    return { firstName: parts[0], lastName: parts[1] };
  } else {
    return { firstName: parts[1], lastName: parts.slice(2).join(' ') };
  }
};
